import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _LoanDestination, _LoanLine } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { MyEditor } from "../../../theme/Component/MyEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { CompanyEditor } from "../../../erp/cellEditor/Company/CompanyEditor";
import { BusinessProcessSelect } from "../../../bpm/config/Componentes/BusinessProcessSelect";
import { LoanDestinationSelect } from "../../../Talentohumano/GestionTH/EmployeeContract/LoanDestination/LoanDestinationSelect";
import { AmortizationTypeSelect } from "./AmortizationTypeSelect";
import { LoanCurrencySelect } from "../LoanDestination/LoanCurrency/LoanCurrencySelect";
import { ThirdLoanEntitySelect } from "../ThirdLoanEntity/ThirdLoanEntitySelect";
import { QuotaTimeTermSelect } from "../QuotaTimeTerm/QuotaTimeTermSelect";
import { LoanTimeTermSelect } from "../LoanTimeTerm/LoanTimeTermSelect";
import { LoanLinePayroollByLoanLine } from "./LoanLinePayroollByLoanLine";
import { LoanLineSelect } from "./LoanLineSelect";
import { LoanConceptSelect } from "../LoanAccountantConcept/LoanConceptSelect";
import { SelecDireccion } from "../SelecDireccion/SelecDireccion";
import { PayrollFactorVdosSelect } from "../../../Talentohumano/ParametrosTalentoHumano/PayrollFactorVdos/PayrollFactorVdosSelect";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { LoanParameters } from "./LoanParameters";
import { SystemPropertie } from "../../configuracion/SystemProperties";
import { SelectLoanConfigProfile } from "../../../custom/forpo/components/Credit/Procesos/SelectLoanConfigProfile";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BudgetAccountantOperationSelect } from "../../../erp/cellEditor/BudgetAccountantOperation/BudgetAccountantOperationSelect";
import { InputMoney } from "../../../theme/Input/InputMoney";




export const LoanLine = () => {

    const loanLine = useDataBean(_LoanLine);
    const single = Singleton.getInstance();
    const [line, setLine] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [loanline, setLoanline] = useState<number>(null);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalcajas, setModalcajas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const modalParametros = useModal("Párametros", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        loanLine.instance.getLoanLineCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        loanLine.setBean({
            // IDCompany: company,
        });
        setLoanline(null);
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        loanLine.deleteItemVoid(loanLine.bean.IDLoanLine).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        loanLine.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDLoanLine', visible: true },
        { title: 'Prefijo', property: 'LoanNumberPrefix', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: false },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Perfil de Configuración', property: 'LoanConfigProfileName', visible: true },
        { title: 'Servicio Contable/Presupuestal para Creditos Nuevos', property: 'BudgetAccountantOperationNewName', visible: true },
        { title: 'Servicio Contable/Presupuestal para Aplicación de Cartera Nuevos', property: 'BudgetAccountantOperationPaymentName', visible: true },
        { title: 'Orden en Lista', property: 'RowOrder', visible: true },
        { title: 'Habilitado', property: 'Enabled', visible: true },
        { title: 'Requiere codeudor', property: 'RequiresCodebtor', visible: true },
        { title: 'Rango Cuotas', property: 'QuotaRange', visible: true },
        { title: 'Escala Monto', property: 'QuotaScale', visible: true, mask: MASK_MONEY },
        { title: 'Habilitar Destino a Analista', property: 'EnableLoanDestination', visible: false },
        { title: 'Mínimo Tiempo Servicio', property: 'MinimumServiceTime', visible: true },
        { title: 'Mínimo Valor de Crédito', property: 'MinimumLoanAmount', visible: true, mask: MASK_MONEY },
        { title: 'Máximo Valor de Crédito', property: 'MaximumLoanAmount', visible: true, mask: MASK_MONEY },
        { title: 'Interes Corriente', property: 'CurrentPercentInterest', visible: true },
        { title: 'Interes por Mora', property: 'ExpiredPercentInterest', visible: true },
        { title: 'Porcentaje del Saldo Base para Habilitar Refinanciación', property: 'LeftPercentForRefinancing', visible: true },
        { title: 'Plazo Base para Habilitar Refinanciación', property: 'LeftTimeForRefinancing', visible: true },
        { title: 'Organización', property: 'IDCompany', visible: true },
        { title: 'Proceso BPM para crédito', property: 'BusinessProcessName', visible: true },
        { title: 'Destino Crédito', property: 'LoanDestinationName', visible: true },
        { title: 'Tipo de Amortización', property: 'AmortizationTypeName', visible: false },
        { title: 'Tipo de Moneda', property: 'IDLoanCurrency', visible: true },
        { title: 'Factor de Descuento de Nóminao', property: 'PayrollFactorName', visible: true },
        { title: 'Es Crédito de Tercero Administrado', property: 'IsThirdLoan', visible: false },
        { title: 'Tercero Administrado', property: 'IDThirdLoanEntity', visible: false },
        { title: 'Configuración Contable Crédito Normal', property: 'LoanAccountantConceptForCurrentName', visible: false },
        { title: 'Configuración Contable Crédito Difícil Cobro', property: 'LoanAccountantConceptForDefeatName', visible: false },
        { title: 'Configuración Plazo Línea', property: 'IDLoanTimeTerm', visible: false },
        { title: 'Configuración Tipo Plazo Cuota', property: 'IDQuotaTimeTerm', visible: false },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${loanLine.bean.Name}`, "view": true }) } },
            { titulo: 'Parametros', icono: 'ri-settings-3-line', visible: single.canEdit(), evento: () => { modalParametros.open() } },
            { titulo: 'Configurar Cajas Nominadoras', icono: 'ri-settings-3-line', visible: single.canEdit(), evento: () => { setModalcajas({ ...modalcajas, "name": `Cajas`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Líneas de Crédito">
            <div className="row">
                {/* <div className="col-md-4"> <CompanyEditor id={company} onchange={(e) => { setCompany(e) }} /></div> */}
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={loanLine.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Orden en Lista</label>
                                <input type="text" name="RowOrder" className="form-control" value={loanLine.bean.RowOrder} onChange={loanLine.handleChange} />

                            </div>

                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={loanLine.bean.Name} onChange={loanLine.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={loanLine.bean.Code} onChange={loanLine.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <SelectLoanConfigProfile label="Perfil de Configuración" idSelector={loanLine.bean.IDLoanConfigProfile} onChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IDLoanConfigProfile": e.IDLoanConfigProfile }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <BudgetAccountantOperationSelect label="Servicio Contable/Presupuestal para Creditos Nuevos" idSelector={loanLine.bean.IDBudgetAccountantOperationForNew}
                                    onChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IDBudgetAccountantOperationForNew": e }) }}
                                />
                            </div>
                            <div className="col-md-6">
                                <BudgetAccountantOperationSelect label="Servicio Contable/Presupuestal para Aplicación de Cartera Nuevos" idSelector={loanLine.bean.IDBudgetAccountantOperationForPayment}
                                    onChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IDBudgetAccountantOperationForPayment": e }) }}
                                />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Habilitado" estado={loanLine.bean.Enabled} eventChange={(e) => { loanLine.setBean({ ...loanLine.bean, "Enabled": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Requiere codeudor" estado={loanLine.bean.RequiresCodebtor} eventChange={(e) => { loanLine.setBean({ ...loanLine.bean, "RequiresCodebtor": e }) }} />
                            </div>
                            {/* <div className="col-md-6">
                                <label>Mínimo de Cuotas</label>
                                <input type="text" name="MinQuotas" className="form-control" value={loanLine.bean.MinQuotas} onChange={loanLine.handleChange} />
                            </div> */}
                            {/* <div className="col-md-6">
                                <label>Máximo de Cuotas</label>
                                <input type="text" name="MaxQuotas" className="form-control" value={loanLine.bean.MaxQuotas} onChange={loanLine.handleChange} />
                            </div> */}
                            <div className="col-md-6">
                                <label>Rango Cuotas</label>
                                <input type="text" name="QuotaRange" className="form-control" value={loanLine.bean.QuotaRange} onChange={loanLine.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Habilitar Destino a Analista" estado={loanLine.bean.EnableLoanDestination} eventChange={(e) => { loanLine.setBean({ ...loanLine.bean, "EnableLoanDestination": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Prefijo Línea de Crédito</label>
                                <input type="text" name="LoanNumberPrefix" className="form-control" value={loanLine.bean.LoanNumberPrefix} onChange={loanLine.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Mínimo Tiempo Servicio</label>
                                <input type="number" name="MinimumServiceTime" className="form-control" value={loanLine.bean.MinimumServiceTime} onChange={loanLine.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Mínimo Valor de Crédito</label>
                                <InputMoney _value={loanLine.bean.MinimumLoanAmount} onChange={(e) => { loanLine.setBean({ ...loanLine.bean, MinimumLoanAmount: e }) }} _label=" " />

                            </div>
                            <div className="col-md-6">
                                <label>Máximo Valor de Crédito</label>
                                <InputMoney _value={loanLine.bean.MaximumLoanAmount} onChange={(e) => { loanLine.setBean({ ...loanLine.bean, MaximumLoanAmount: e }) }} _label=" " />
                            </div>
                            
                            <div className="col-md-6">
                                <label>Escala Valor</label>
                                <input type="number" name="QuotaScale" className="form-control" value={loanLine.bean.QuotaScale} onChange={loanLine.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Interes Corriente</label>
                                <input type="text" name="CurrentPercentInterest" className="form-control" value={loanLine.bean.CurrentPercentInterest} onChange={loanLine.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Interes por Mora</label>
                                <input type="text" name="ExpiredPercentInterest" className="form-control" value={loanLine.bean.ExpiredPercentInterest} onChange={loanLine.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Porcentaje del Saldo Base para Habilitar Refinanciación</label>
                                <input type="text" name="LeftPercentForRefinancing" className="form-control" value={loanLine.bean.LeftPercentForRefinancing} onChange={loanLine.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Plazo Base para Habilitar Refinanciación</label>
                                <input type="text" name="LeftTimeForRefinancing" className="form-control" value={loanLine.bean.LeftTimeForRefinancing} onChange={loanLine.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Organización</label>
                                <CompanyEditor id={loanLine.bean.IDCompany} onchange={(e: any) => { loanLine.setBean({ ...loanLine.bean, "IDCompany": e }) }}></CompanyEditor>
                            </div>
                            <div className="col-md-6">
                                <BusinessProcessSelect label="Proceso BPM para crédito" idSelector={loanLine.bean.IDBusinessProcess} onChange={(e: any) => { loanLine.setBean({ ...loanLine.bean, "IDBusinessProcess": e }) }} />
                            </div>
                            <div className="col-md-6">

                                <LoanDestinationSelect label="Destino Crédito" idSelector={loanLine.bean.IDLoanDestination} onChange={(e: any) => { loanLine.setBean({ ...loanLine.bean, "IDLoanDestination": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <AmortizationTypeSelect idSelector={loanLine.bean.IDAmortizationType} onChange={(e: any) => { loanLine.setBean({ ...loanLine.bean, "IDAmortizationType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <LoanCurrencySelect idSelector={loanLine.bean.IDLoanCurrency} onChange={(e: any) => { loanLine.setBean({ ...loanLine.bean, "IDLoanCurrency": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Es Crédito de Tercero Administrado" estado={loanLine.bean.IsThirdLoan} eventChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IsThirdLoan": e }) }} />
                            </div>
                            {loanLine.bean.IsThirdLoan && (
                                <div className="col-md-6">
                                    <ThirdLoanEntitySelect idSelector={loanLine.bean.IDThirdLoanEntity} onChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IDThirdLoanEntity": e }) }} />
                                </div>
                            )}

                            <div className="col-md-6">
                                <LoanTimeTermSelect idSelector={loanLine.bean.IDLoanTimeTerm} onChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IDLoanTimeTerm": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <QuotaTimeTermSelect idSelector={loanLine.bean.IDQuotaTimeTerm} onChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IDQuotaTimeTerm": e }) }} />
                            </div>

                            <div className="col-md-12">
                                <LoanLineSelect label="Selecciona Una Linea de Credito para Configuración Contable Crédito Normal /  Difícil Cobro*" idSelector={loanline} onChange={(e) => { setLoanline(e) }} />
                            </div>
                            {loanline && (
                                <>
                                    <div className="col-md-6">
                                        <LoanConceptSelect
                                            label="Configuración Contable Crédito Normal*"
                                            LoanLine={loanline}
                                            idSelector={loanLine.bean.IDLoanAccountantConceptForCurrent}
                                            onChange={(e) => {
                                                loanLine.setBean({
                                                    ...loanLine.bean,
                                                    "IDLoanAccountantConceptForCurrent": e
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <LoanConceptSelect
                                            label="Configuración Contable Crédito Difícil Cobro*"
                                            LoanLine={loanline}
                                            idSelector={loanLine.bean.IDLoanAccountantConceptForDefeat}
                                            onChange={(e) => {
                                                loanLine.setBean({
                                                    ...loanLine.bean,
                                                    "IDLoanAccountantConceptForDefeat": e
                                                });
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            <div className="col-md-6">
                                <PayrollFactorVdosSelect label="Factor de Descuento de Nómina" typeFortnight={39} render={loanLine.bean.PayrollFactorName} idSelector={loanLine.bean.IDPayrollFactor} onChange={(e) => { loanLine.setBean({ ...loanLine.bean, "IDPayrollFactor": e.IDPayrollFactor, "PayrollFactorName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <MyEditor val={loanLine.bean.Description} onChange={(e: any) => { loanLine.setBean({ ...loanLine.bean, 'Description': e }) }} ></MyEditor>
                            </div>
                            {/* <PrintJson json={loanLine.bean}/> */}
                        </div>
                    </Modal>
                    <Modal modal={modalcajas} updateModal={setModalcajas}>
                        <div className="row">
                            <LoanLinePayroollByLoanLine idLoanLine={loanLine.bean.IDLoanLine} />
                        </div>
                    </Modal>
                    <Modal modal={modalParametros.modal} updateModal={modalParametros.setModal}>
                        <SystemPropertie appName={`LOAN_${loanLine.bean.LoanNumberPrefix}`} />
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {loanLine.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}